export default "__VITE_ASSET__f680f401__"